import {Component, ComponentOptions, LayoutOptions, PartsOptions} from "@mecatran-components/component";
import { DataSourceList, DataSourceListOptions } from "@mecatran-components/datasourcelist"

/**
 * should be renamed schoolSuggestionList 
 */




export class SuggestionList extends DataSourceList{
    constructor(suggestionListOptions){
        super(suggestionListOptions);



    }
    // ==========
    // private 
    // ----------
    getStrName(stop){
        if (!stop) return;
        var str = `${stop.name} ${stop.city}`;
        if (stop.city2) str += stop.city2;
        return str;
    }

    getStopName(stop){
        if (!stop) return;
        var str = `${stop.name}`;
        return str; 
    }

    getCityName(stop){
        if (!stop) return;
        var str = stop.city;
        if (stop.city2) str += stop.city2;
        return str; 
    }

    getIcone(stop){
        var icon; 
        switch(stop.getIsSchool()){
            case true: 
                icon = "./assets/school.png";
                break;
            case false:
                icon = "./assets/home.png";
        }

        return icon;
    }

    // ==========
    // overload 
    // ----------
    createItemComponent(stop){
        var createContainerNode = ()=>{
            var div = document.createElement('div');
            div.classList.add('selectable')
            return div; 
        }
        var createContentNodes = ()=>{
            var img = document.createElement('img');
            img.src = this.getIcone(stop);
            
            var name = document.createElement('div');
            name.classList.add('stop-name');

            var spanStopName = document.createElement('span');
            spanStopName.innerHTML = this.getStopName(stop);

            var spanCityName = document.createElement('span');
            spanCityName.innerHTML = this.getCityName(stop);
            name.appendChild(spanStopName);
            name.appendChild(spanCityName);

            // var br = document.createElement('br');
            return [img, name];

/*
<input id="clear" type="image" src="./assets/cross.svg" width="20px" class="clear" style="vertical-align:middle">
*/
        }
        var containerOptions = new PartsOptions(createContainerNode);
        var contentOptions = new PartsOptions(createContentNodes)
        var componentOptions = new ComponentOptions(containerOptions,contentOptions);
        var component = new Component(componentOptions);
        component.getData = ()=>stop 
        //component.build();
        return component;
    }

    createContainerNode(){
        var div = document.createElement('div');
        div.classList.add('suggestion-list');
        return div;
    }



}


/**
 * SchoolSuggestionList extends DataSourceListOptions 
 */
export class SuggestionListOptions extends DataSourceListOptions{
    constructor(param){ super(param)}
}